import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

import styles from './styles.module.scss'

const ImagesComponent = ({
  partnerLogo,
  sponsorLogo,
  anyPhotos,
  organizerLogo,
  images,
}) => {
  const titleMessage = useMemo(() => {
    if (partnerLogo) return <FormattedMessage id='community.partners' />
    if (sponsorLogo) return <FormattedMessage id='community.sponsors' />
    if (anyPhotos) return <FormattedMessage id='community.photos' />
    if (organizerLogo) return <FormattedMessage id='community.organizer' />

    return null
  }, [partnerLogo, sponsorLogo, anyPhotos, organizerLogo])

  const imagesList = useMemo(() => {
    if (!images?.length) return null

    return images.map((el, index) => (
      <img key={index} className={styles.organizer__image} src={el} alt='' />
    ))
  }, [images])

  const articleClassName = useMemo(
    () => classNames('eventBodyBg', styles.events__organizer__team),
    []
  )

  return (
    <>
      <h4 className={styles.events__about__title}>{titleMessage}</h4>
      <article className={articleClassName}>
        <div className={styles.events__games__container}>{imagesList}</div>
      </article>
    </>
  )
}

export default ImagesComponent
